<template>
  <v-dialog
    v-model="isActive"
    persistent
    max-width="600"
  >
    <v-card
      v-bind="$attrs"
    >
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text
        class="align-start d-flex pt-4"
      >
        <v-icon
          size="64"
        >
          mdi-alert-circle-outline
        </v-icon>
        <div
          class="flex-grow-1 pl-4"
        >
          <slot />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          text
          color="primary"
          @click="closeDialog"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NotificationDialog',
  inheritAttrs: false,

  model: {
    prop: 'active',
    event: 'change',
  },

  props: {
    active: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    isActive: {
      get () {
        return this.active === true
      },

      set (newVal) {
        this.$emit('change', newVal === true)
      },
    },
  },

  methods: {
    closeDialog () {
      this.isActive = false
    },
  },
}
</script>
